import React, { useCallback, useState } from 'react'

import { Stack } from 'component-library-next'
import { BiChevronDown, BiChevronUp } from 'react-icons/bi'

import {
  ProfessionalAuditOutcome,
  ProfessionalAuditReport,
  ProfessionalAuditType
} from '@app/graphql/types'
import { StructuredTextDisplay } from '@app/lib/display/StructuredTextDisplay/StructuredTextDisplay'
import { AuditReportClauseEffectiveness } from '@app/modules/Messages/Components/Answer/AuditReportView/AuditReportClauseEffectiveness'

import './AuditReportView.scss'

export type AuditReportViewProps = {
  topicName: string
  report: ProfessionalAuditReport
}

export const AuditReportView = ({ topicName, report }: AuditReportViewProps) => {
  const [expanded, setExpanded] = useState(false)

  const toggle = useCallback(() => {
    setExpanded((val) => !val)
  }, [])

  const findings = report.sections.find((section) => section.uid === 'AuditReport.Section.Findings')

  const recommendations = report.sections.find(
    (section) => section.uid === 'AuditReport.Section.Recommendations'
  )

  return (
    <div className='audit-report mecl-message-content__wrapper mecl-message-content__wrapper--answer'>
      <Stack gap={Stack.gap.medium}>
        <a className='audit-report__toggle' onClick={toggle}>
          <span>Prüfungsbericht hier ansehen</span>
          {expanded ? <BiChevronUp /> : <BiChevronDown />}
        </a>
        {expanded && (
          <Stack gap={Stack.gap.large}>
            {[
              ProfessionalAuditType.AdvocardRenovationClauseAudit,
              ProfessionalAuditType.AdvocardUtilityBillAudit,
              ProfessionalAuditType.RoutineUtilityBillAudit
            ].includes(report.auditType) && (
              <AuditReportClauseEffectiveness
                topicName={topicName}
                effectiveness={
                  (findings && findings.outcome) || ProfessionalAuditOutcome.Inconclusive
                }
              />
            )}

            {findings && (
              <Stack gap={Stack.gap.small}>
                <div className='audit-report__heading'>Ergebnis und Begründung im Detail</div>
                <StructuredTextDisplay nodes={findings.summary as any} />
              </Stack>
            )}

            {recommendations && recommendations.summary.length > 0 && (
              <Stack gap={Stack.gap.small}>
                <div className='audit-report__heading'>Handlungsempfehlung</div>
                <StructuredTextDisplay nodes={recommendations.summary as any} />
              </Stack>
            )}
          </Stack>
        )}
      </Stack>
    </div>
  )
}
